import { render, staticRenderFns } from "./ZonePieChart.vue?vue&type=template&id=d8fb5920&"
import script from "./ZonePieChart.vue?vue&type=script&lang=ts&"
export * from "./ZonePieChart.vue?vue&type=script&lang=ts&"
import style0 from "./ZonePieChart.vue?vue&type=style&index=0&id=d8fb5920&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QBtn,QMenu,QList,QItem,QItemSection,QBtnToggle,QCardSection,QBtnGroup,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QBtn,QMenu,QList,QItem,QItemSection,QBtnToggle,QCardSection,QBtnGroup})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
